import React, { ComponentType } from 'react'
import { Route, RouteProps, Switch } from "react-router"

const list: {
    [key: string]: string
} = {}

export default class Router {
    static create = (group: RoutePagesGroup) => {
        return Router.group({}, group).component
    }

    static page = ({ name, path, component }: RouterPageProps): RouterPage => {
        if (Array.isArray(name)) {
            for (const item of name)
                list[item] = path
        } else {
            list[name] = path
        }

        return { path, component }
    }
    
    static group = (props: RouteGroupProps, group: RoutePagesGroup) => {
        const Template = props.template || EmptyComponentWithChildren
        const Middleware = props.middleware || EmptyRouteWithChildren
        const path = Router.flattenPathArray(group.map(item => item.path))

        const component = () => (
            <Middleware exact path={path}>
                <Template>
                    <Switch>
                        {group.map((element, idx) => <Route key={idx} exact path={element.path} component={element.component} />)}
                    </Switch>
                </Template>
            </Middleware>
        )

        return { component, path }
    }

    static notFound({ component }: RouteProps) {
        return { path: "*", component }
    }

    static getPathByName(name: string) {
        const path = list[name]
        if (!path) throw "Can't find a path by name: " + name
        return path
    }

    static getHrefByName(name: string, ...params: (string | number | null)[]) {
        let result = this.getPathByName(name)

        for (const param of params) {
            if (param === null) {
                result = result.replace(/\/:(\w+)/, ''); 
                continue;
            }

            result = result.replace(/:(\w+)/, param.toString())
        }
        
        return result
    }

    static flattenPathArray(array: (string | string[])[]): string[] {
        let result: string[] = []

        for (const path of array) {
            if (Array.isArray(path)) {
                result.push(...Router.flattenPathArray(path))
                continue
            }

            result.push(path)
        }

        return result
    }
}

// COMPONENTS
const EmptyComponentWithChildren = (({ children }: React.PropsWithChildren<{}>) => <>{children}</>)
const EmptyRouteWithChildren = (({ children, ...props }: React.PropsWithChildren<{}> & RouteProps) => (
    <Route {...props}>{children}</Route>
))

// TYPES
type RouterPage = {
    path: string | string[]
    component?: ComponentType
}

type RouterPageProps = RouteProps & {
    name: string | string[]
    path: string
    middleware?(props: RouteProps): JSX.Element
}

type RoutePagesGroup = RouterPage[]

type RouteGroupProps = {
    template?: ComponentType
    middleware?(props: RouteProps): JSX.Element
}